var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n\t.st0{fill:#4B4B4B;}\r\n\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "336.156,239.469 280.922,239.469 274.984,248.688 274.984,270.797 336.156,270.797 336.156,270.875  336.156,297.703 336.156,302.188 274.984,302.188 274.984,349.563 237,349.563 237,302.188 175.844,302.188 175.844,297.703  175.844,270.875 175.844,270.797 237,270.797 237,248.719 231.063,239.469 175.844,239.469 175.844,212.656 213.813,212.656  181.531,162.422 213.719,162.422 255.984,228.188 298.266,162.422 330.453,162.422 298.203,212.656 336.156,212.656  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,64c105.875,0,192,86.125,192,192s-86.125,192-192,192c-105.859,0-192-86.125-192-192S150.141,64,256,64  M256,0C114.609,0,0,114.625,0,256c0,141.391,114.609,256,256,256c141.375,0,256-114.609,256-256C512,114.625,397.375,0,256,0z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeePlan);
export default __webpack_public_path__ + "static/media/FeePlan.3c39579e90597daba285695c5dedccc7.svg";
export { ForwardRef as ReactComponent };